import { IAction } from "redux-micro-frontend"
import { Actions } from "./leftNavigation.action.types"
import { ILeftNavigationGroup } from "./leftNavigation.model"
export const setLeftnav = (payload: ILeftNavigationGroup): IAction<ILeftNavigationGroup> => {
    return {
        type: Actions.SET_LEFTNAV,
        payload: payload
    }
}